import { render, staticRenderFns } from "./tile.vue?vue&type=template&id=7a0dc869&scoped=true"
var script = {}
import style0 from "./tile.vue?vue&type=style&index=0&id=7a0dc869&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0dc869",
  null
  
)

export default component.exports